import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { EnvironmentLevel } from '../../core/environment/environment-level';

@Pipe({
  name: 'environmentLevel',
  standalone: true,
  pure: false,
})
export class EnvironmentLevelPipe implements PipeTransform {
  private readonly _transloco = inject(TranslocoService);

  transform(value: EnvironmentLevel): string {
    switch (value) {
      case EnvironmentLevel.Development:
        return this._transloco.translate('enums.environmentLevel.development');
      case EnvironmentLevel.Stage:
        return this._transloco.translate('enums.environmentLevel.staging');
      case EnvironmentLevel.Production:
        return this._transloco.translate('enums.environmentLevel.production');
      default:
        return this._transloco.translate('enums.environmentLevel.local');
    }
  }
}
